<template>
    <div class="solutionguide__step-wrapper">
        <p class="lead">{{$t(step+'.headline', { segment: $store.state.segment && $store.state.segment.name, application: $store.state.application && $store.state.application.name, component: $store.state.component && $store.state.component.name })}}</p>
        <slot />
    </div>
</template>

<script lang="ts">
    import Vue from "vue";
    import {mapGetters, mapState} from "vuex";

	export default Vue.extend({
        name: "step-wrapper",
        props: {
            step: {
                type: String,
                required: true
            }
        },
        computed: {
            ...mapState(['segment'])
        },
        methods: {
        }
    })
</script>
